var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRateSmall = function SvgRateSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7081 3.93171L7.32651 3.4144L5.8108 0.181082C5.69759 -0.0603607 5.30205 -0.0603607 5.18885 0.181082L3.6736 3.4144L0.292026 3.93171C0.0142767 3.9744 -0.0966397 4.31269 0.0981514 4.51236L2.55481 7.0342L1.9741 10.5994C1.92781 10.8826 2.22985 11.0951 2.47965 10.956L5.50005 9.2843L8.52046 10.9565C8.76796 11.0942 9.07275 10.8858 9.026 10.5998L8.4453 7.03466L10.902 4.51282C11.0967 4.31269 10.9854 3.9744 10.7081 3.93171V3.93171Z",
    fill: "currentcolor"
  })));
};
export default SvgRateSmall;